import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "header__title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "content__description" }
const _hoisted_6 = { for: "file-input" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "content__drop-zone__add-file__text" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = { class: "content__drop-zone__add-file__icon" }
const _hoisted_11 = { class: "content__drop-zone__add-file__text" }
const _hoisted_12 = { class: "content__drop-zone__add-file__text__highlight" }
const _hoisted_13 = {
  key: 0,
  class: "content__file-list"
}
const _hoisted_14 = ["file"]
const _hoisted_15 = { class: "content__file-list__row__text" }
const _hoisted_16 = { class: "content__file-list__row__status" }
const _hoisted_17 = {
  key: 0,
  class: "content__file-list__row__status__loading-spinner"
}
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "footer"
}

import { computed, ref, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { useGeneralStore } from '@/pinia'

import ButtonPrimary from '@/design-system/atoms/buttons/ButtonPrimary.vue'
import IconCheck from '@/design-system/assets/icons/IconCheck.vue'
import IconPaperclip from '@/design-system/assets/icons/IconPaperclip.vue'
import IconUpload from '@/design-system/assets/icons/IconUpload.vue'
import IconX from '@/design-system/assets/icons/IconX.vue'
import IconXCircleMedium from '@/design-system/assets/icons/IconXCircleMedium.vue'
import InputFileDrop from '@/design-system/atoms/InputFileDrop.vue'
import LayoutOverlay from '@/design-system/templates/LayoutOverlay.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import useFileList from '@/hooks/attachments/useFileList'
import createFileUploader from '@/hooks/attachments/useFileUploader'

// emits
interface EMITS {
  (e: 'closeUploadFilesModal', val: boolean)
}

export default /*@__PURE__*/_defineComponent({
  __name: 'ModalUploadTicketFiles',
  emits: ["closeUploadFilesModal"],
  setup(__props, { emit: __emit }) {

const emits = __emit

// variables
const { t } = useI18n()
const piniaStore = useGeneralStore()
const { filesUpload, addFiles, removeFile } = useFileList()
const { uploadFiles } = createFileUploader()

const fileInput = ref<HTMLInputElement | null>(null)

// computed
const selectedTicket = computed(() => piniaStore.selectedTicket)

const descriptionText = computed<string>(() => {
  let description = ''
  if (!selectedTicket.value) return description
  description = `${t('message__files-upload__part1')} ${t(
    'message__files-upload__part2-connection'
  )} "${selectedTicket.value.title}".`

  return description
})
const isUploadingFiles = computed(() => {
  return filesUpload.value.some((file) => file.status === 'loading' || file.status === null)
})

// methods
function clickFileInput(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  if (fileInput.value) fileInput.value.click()
}
function closeModal() {
  piniaStore.setFilesUploaded(null)
  emits('closeUploadFilesModal', false)
}
function onInputChange(event) {
  addFiles(event.target.files)
  event.target.value = null
}

// watches
watch(filesUpload, async () => {
  if (filesUpload.value.length && selectedTicket.value) {
    await uploadFiles(filesUpload.value, selectedTicket.value.id, 'TICKET')
  }
  // Add files to pinia store for refreshing list in FilesDashboard
  let uploadedFilesArray: string[] = []
  filesUpload.value.forEach((file) => {
    if (file.status === true) uploadedFilesArray.push(file.id)
  })
  piniaStore.setFilesUploaded(uploadedFilesArray)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LayoutOverlay, {
    class: "modal-upload-files",
    onCloseOverlay: _cache[3] || (_cache[3] = ($event: any) => (closeModal()))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("h3", _hoisted_3, _toDisplayString(_unref(t)('general__data__file-upload-v2')), 1),
          (!_unref(filesUpload).length)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "header__close-button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (closeModal()))
              }, [
                _createVNode(IconXCircleMedium, { class: "header__close-button__icon" })
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", _hoisted_5, _toDisplayString(descriptionText.value), 1),
          _createVNode(InputFileDrop, {
            class: "content__drop-zone",
            tabindex: "0",
            onFilesDropped: _unref(addFiles),
            onKeydown: [
              _withKeys(clickFileInput, ["enter"]),
              _cache[1] || (_cache[1] = _withKeys((event) => clickFileInput(event, true), ["space"]))
            ]
          }, {
            default: _withCtx(({ dropZoneActive }) => [
              _createElementVNode("label", _hoisted_6, [
                dropZoneActive
                  ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(_unref(t)('general__data__file-drop')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, [
                      _createElementVNode("span", _hoisted_10, [
                        _createVNode(IconUpload)
                      ]),
                      _createElementVNode("span", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('general__data__file-add')), 1),
                        _createTextVNode(" " + _toDisplayString(_unref(t)('general__data__file-drop-or').toLowerCase()) + " ", 1),
                        _cache[4] || (_cache[4] = _createElementVNode("br", null, null, -1)),
                        _createTextVNode(" " + _toDisplayString(_unref(t)('general__data__upload-will-start').toLowerCase()), 1)
                      ])
                    ])),
                _createElementVNode("input", {
                  id: "file-input",
                  ref_key: "fileInput",
                  ref: fileInput,
                  type: "file",
                  multiple: "",
                  onChange: onInputChange
                }, null, 544)
              ])
            ]),
            _: 1
          }, 8, ["onFilesDropped"]),
          (_unref(filesUpload).length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filesUpload), (file) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: file.id,
                    class: _normalizeClass(["content__file-list__row", { 'content__file-list__row__error': file.status === false }]),
                    file: file
                  }, [
                    _createVNode(IconPaperclip, { class: "content__file-list__row__icon" }),
                    _createElementVNode("span", _hoisted_15, _toDisplayString(file.file.name), 1),
                    _createElementVNode("span", _hoisted_16, [
                      (file.status === 'loading')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                            _createVNode(PulseLoader, {
                              color: "#3f46d6",
                              size: "8px"
                            })
                          ]))
                        : _createCommentVNode("", true),
                      (file.status === true)
                        ? (_openBlock(), _createBlock(IconCheck, {
                            key: 1,
                            class: "content__file-list__row__status__icon-success"
                          }))
                        : _createCommentVNode("", true),
                      (file.status === false)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 2,
                            class: "content__file-list__row__status__button",
                            "aria-label": "Remove failed file",
                            onClick: ($event: any) => (_unref(removeFile)(file))
                          }, [
                            _createVNode(IconX, { class: "content__file-list__row__status__button__icon-error" })
                          ], 8, _hoisted_18))
                        : _createCommentVNode("", true)
                    ])
                  ], 10, _hoisted_14))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(filesUpload).length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              _createVNode(ButtonPrimary, {
                class: "footer__button",
                buttonText: _unref(t)('general__text__done'),
                disabled: isUploadingFiles.value,
                onOnClicked: _cache[2] || (_cache[2] = ($event: any) => (closeModal()))
              }, null, 8, ["buttonText", "disabled"])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }))
}
}

})